import { utc as f } from "@date-fns/utc";
import { startOfDay as y } from "date-fns";
import { memoize as p } from "lodash-es";
import i from "zod";
function r(t, e) {
  const n = e ?? /* @__PURE__ */ new Date(), c = new Intl.DateTimeFormat("en-US", {
    hour12: !1,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    timeZone: t
  }).formatToParts(n), o = (u) => {
    var a;
    return +(((a = c.find((m) => m.type === u)) == null ? void 0 : a.value) ?? 0);
  }, s = Date.UTC(
    o("year"),
    o("month") - 1,
    o("day"),
    o("hour") % 24,
    // some engines render midnight as "24"
    o("minute"),
    o("second")
  );
  return Math.round((n.getTime() - s) / 6e4);
}
const h = (t, e) => {
  const n = new Date(e);
  return n.setUTCMinutes(n.getUTCMinutes() + r(t, n)), n;
}, T = (t, e) => {
  const n = e ? new Date(e) : /* @__PURE__ */ new Date();
  return n.setUTCMinutes(n.getUTCMinutes() - r(t, n)), n;
}, M = (t) => y(T(t), {
  in: f
});
function O(t, e) {
  const n = p(async function(...c) {
    try {
      return await t(...c);
    } catch (o) {
      throw n.cache.delete(e ? e(...c) : c[0]), o;
    }
  }, e);
  return n;
}
const C = (t) => Object.assign(
  t,
  t.reduce((e, n) => (e[n.id] = n, e), [])
), A = (t) => {
  const e = t.data();
  return "id" in e || (e.id = t.id), e;
}, d = (t) => Object.fromEntries(
  Object.entries(t).filter(([, e]) => e !== void 0)
), l = (t) => i.codec(
  i.any(),
  i.any(),
  {
    decode: (e) => t.parse(e),
    encode: (e) => d(t.encode(e))
  }
), z = (t) => i.codec(
  i.any(),
  i.any(),
  {
    decode: (e) => t.parseAsync(e),
    encode: async (e) => d(await t.encodeAsync(e))
  }
);
export {
  C as arrayAndMap,
  M as getNaiveToday,
  r as getTimeOffset,
  A as identityDocMapper,
  O as memoizeAsync,
  h as naiveToRealDate,
  T as realToNaiveDate,
  d as stripUndefined,
  l as stripUndefinedOnEncode,
  z as stripUndefinedOnEncodeAsync
};
//# sourceMappingURL=utils.js.map
